var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8545 14.0003L21.0498 8.80501C21.2963 8.55888 21.435 8.22488 21.4353 7.87648C21.4357 7.52809 21.2976 7.19385 21.0514 6.94728C20.8053 6.70071 20.4713 6.56201 20.1229 6.56171C19.7745 6.5614 19.4403 6.6995 19.1937 6.94564L13.9984 12.1409L8.80306 6.94564C8.55649 6.69907 8.22207 6.56055 7.87337 6.56055C7.52467 6.56055 7.19025 6.69907 6.94368 6.94564C6.69711 7.1922 6.55859 7.52662 6.55859 7.87532C6.55859 8.22402 6.69711 8.55844 6.94368 8.80501L12.139 14.0003L6.94368 19.1956C6.69711 19.4422 6.55859 19.7766 6.55859 20.1253C6.55859 20.474 6.69711 20.8084 6.94368 21.055C7.19025 21.3016 7.52467 21.4401 7.87337 21.4401C8.22207 21.4401 8.55649 21.3016 8.80306 21.055L13.9984 15.8597L19.1937 21.055C19.4403 21.3016 19.7747 21.4401 20.1234 21.4401C20.4721 21.4401 20.8065 21.3016 21.0531 21.055C21.2996 20.8084 21.4381 20.474 21.4381 20.1253C21.4381 19.7766 21.2996 19.4422 21.0531 19.1956L15.8545 14.0003Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9f7ebcbee8e1bae3f165a3931fc0ac9c.svg";
export { ForwardRef as ReactComponent };